<div class="newsLetter w-100">
  <div class="titlePrincipal">
    <p><strong> Suscríbete </strong></p>
  </div>
  <div class="titleSecondary">

    <p class="fs-6">Mantente al dia con nuestras <br>ultimas noticias y promociones</p>
  </div>
  <form action="" class="mx-auto">
    <input type="email" name="email" id="email" placeholder="example@example.com" />
    <input type="submit" name="submit" value="Suscribirse">
  </form>
</div>
